import { render, staticRenderFns } from "./ItemBuyReport.vue?vue&type=template&id=7f063e19&"
import script from "./ItemBuyReport.vue?vue&type=script&lang=js&"
export * from "./ItemBuyReport.vue?vue&type=script&lang=js&"
import style0 from "./ItemBuyReport.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/projects/accurate/acc-dashboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlideXReverseTransition } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VContainer,VDataTable,VDatePicker,VDialog,VFlex,VLayout,VSlideXReverseTransition,VSpacer,VTextField})
